import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

import reviews from './reviews/reducers';
import alumniFilterService from
  '@vectord/filter-recommendation/dist/filter-services';
import alumniFilterServicesReducer from
  '@vectord/filter-recommendation/dist/filter-reducer';

const staticReducers = {
  reviews,
  [alumniFilterService.reducerPath]: alumniFilterService.reducer,
  alumniFilterService: alumniFilterServicesReducer,
};

const middleware = [
  thunk,
  alumniFilterService.middleware,
];

const createReducers = (asyncReducers) => {
  const reducers = combineReducers({
    ...asyncReducers,
    ...staticReducers,
  });

  return reducers;
};

const configureStore = () => {
  const store = createStore(createReducers(), applyMiddleware(...middleware));


  store.asyncReducers = {};

  store.injectReducer = (asyncReducersData) => {
    store.asyncReducers = { ...store.asyncReducers, ...asyncReducersData };
    store.replaceReducer(createReducers(store.asyncReducers));
  };

  return store;
};

export default configureStore;
